export default {
  DISPLAY_ALL_RECORDS_MERHANT_INFO: 'DISPLAY_ALL_RECORDS_MERHANT_INFO',
  ADD_MERHANT_INFO: 'ADD_MERHANT_INFO',
  DELETE_MERHANT_INFO: 'DELETE_MERHANT_INFO',
  UPDATE_MERHANT_INFO: 'UPDATE_MERHANT_INFO',

  DISPLAY_ALL_RECORDS_SUB_USERS: 'DISPLAY_ALL_RECORDS_SUB_USERS',
  UPDATE_SUB_USER: 'UPDATE_SUB_USER',
  ADD_SUB_USER: 'ADD_SUB_USER',
  DELETE_SUB_USER: 'DELETE_SUB_USER',

  DISPLAY_ALL_RECORDS_BRANCHS: 'DISPLAY_ALL_RECORDS_BRANCHS',
  ADD_BRANCH: 'ADD_BRANCH',
  UPDATE_BRANCH: 'UPDATE_BRANCH',

  EOD_REPORT: 'EOD_REPORT',
  CURRENT_ACCOUNT_REPORT: 'CURRENT_ACCOUNT_REPORT',
  BABS_REPORT: 'BABS_REPORT',

  PAYMENT_REPORT: 'PAYMENT_REPORT',
  INVOICE_REPORT: 'INVOICE_REPORT',
  PAYE_INVOICE_REPORT: 'PAYE_INVOICE_REPORT',

  APPLICATIONS: 'APPLICATIONS',

  DISPLAY_ALL_RECORDS_ROLE: 'DISPLAY_ALL_RECORDS_ROLE',
  ADD_ROLE: 'ADD_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  UPDATE_ROLE: 'UPDATE_ROLE',

  DISPLAY_ALL_RECORDS_ANNOUNCEMENTS: 'DISPLAY_ALL_RECORDS_ANNOUNCEMENTS',
  ADD_ANNOUNCEMENTS: 'ADD_ANNOUNCEMENTS',
  DELETE_ANNOUNCEMENTS: 'DELETE_ANNOUNCEMENTS',
  UPDATE_ANNOUNCEMENTS: 'UPDATE_ANNOUNCEMENTS',

  DISPLAY_INFORMATION_TERMINAL: 'DISPLAY_INFORMATION_TERMINAL',
  ADD_TERMINAL: 'ADD_TERMINAL',

  DISPLAY_DASHBOARD: 'DISPLAY_DASHBOARD',

  DISPLAY_INFORMATION_USER: 'DISPLAY_INFORMATION_USER',

};